exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Q7bY{display:flex}._2u1nP{display:inline-flex}._17C2j{flex-direction:row}._17C2j._2A2bv{justify-content:flex-start}._17C2j._35xuj{justify-content:center}._17C2j._2qAc9{justify-content:flex-end}._17C2j._2QvF2{align-items:flex-start}._17C2j.lF7lF{align-items:center}._17C2j._3YE3g{align-items:flex-end}._1oEil{flex-direction:column}._1oEil._2A2bv{align-items:flex-start}._1oEil._35xuj{align-items:center}._1oEil._2qAc9{align-items:flex-end}._1oEil._2QvF2{justify-content:flex-start}._1oEil.lF7lF{justify-content:center}._1oEil._3YE3g{justify-content:flex-end}._17C2j._38vV3,._1oEil._38vV3{justify-content:space-between}\n", ""]);

// Exports
exports.locals = {
	"root": "_2Q7bY",
	"inline": "_2u1nP",
	"horizontal": "_17C2j",
	"left": "_2A2bv",
	"center": "_35xuj",
	"right": "_2qAc9",
	"top": "_2QvF2",
	"middle": "lF7lF",
	"bottom": "_3YE3g",
	"vertical": "_1oEil",
	"spaceBetween": "_38vV3"
};